/**
 * Finds a column index by exact header name match.
 * Returns -1 when no candidate matches.
 */
export function findExactColumnIndex(
  headers: string[],
  candidates: string[]
): number {
  for (const name of candidates) {
    const idx = headers.indexOf(name);
    if (idx >= 0) {
      return idx;
    }
  }
  return -1;
}

/**
 * Finds a column index using fuzzy includes matching against normalized headers.
 * Returns 0 when no candidate matches to preserve current row-selection behavior.
 */
export function findFuzzyColumnIndex(
  headers: string[],
  candidates: string[]
): number {
  const normalized = headers.map((header) => header.toLowerCase().trim());
  for (const candidate of candidates) {
    const index = normalized.findIndex((header) => header.includes(candidate));
    if (index >= 0) {
      return index;
    }
  }
  return 0;
}

export function buildRowLabel(row: string[]): string {
  const primary = row[0]?.trim();
  const secondary = row[1]?.trim();
  if (primary && secondary) {
    return `${primary} - ${secondary}`;
  }
  if (primary) {
    return primary;
  }
  return "Untitled row";
}
